import React from 'react';
import styles from './style.css';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import errorIcon from '../../assets/images/cart-error-circle.svg';
import { isTaxable } from '../../flows/shared/utils';

export const CheckboxMessage = ({ consented, submitBtnClick }) =>
  !consented &&
  submitBtnClick && (
    <div>
      <p
        role="alert"
        aria-atomic="true"
        className="consent-ask checkbox-message error-message">
        <img src={errorIcon} alt="Error Icon" className="alert-error-icon" />
        You must acknowledge and agree to the terms and conditions specified
        above.
      </p>
      <style jsx>{styles}</style>
    </div>
  );

export const DocsAndDiscMessage = ({
  docsAndDiscClick,
  submitBtnClick,
  message
}) =>
  submitBtnClick &&
  !docsAndDiscClick && (
    <div>
      <p
        role="alert"
        aria-atomic="true"
        className="consent-ask button-message error-message">
        <img src={errorIcon} className="alert-error-icon" alt="Error Icon" />
        {message}
      </p>
      <style jsx>{styles}</style>
    </div>
  );

export const docAndDiscErrorText = accountType => {
  return !isTaxable(accountType)
    ? 'You must open and review the T. Rowe Price Traditional and Roth IRA Disclosure Statement and Custodial Agreement and Customer Account Agreement'
    : 'You must open and review the Customer Account Agreement PDF';
};

export const ButtonSectionRenderer = ({
  electronicAccessDeliveryConsent,
  docsAndDiscClick,
  setSubmitBtnClick,
  next
}) => {
  const handleSubmitClick = () => {
    setSubmitBtnClick(true);

    if (!docsAndDiscClick || !electronicAccessDeliveryConsent) {
      return setTimeout(() => {
        // focus on the first error message present on the screen
        // offset element by 50 to account for fixed header
        const errorMessage =
          document.querySelector('.error-message').offsetTop - 50;
        window.scroll({ top: errorMessage, behavior: 'smooth' });
      }, 1);
    }

    return next()();
  };

  return (
    <div className="button-container">
      <MFBeaconButton
        id="termsConditionsSubmit"
        data-name="termsConditionsSubmit"
        variant="primary"
        className="beacon-button-margin-override"
        size="normal"
        onClick={handleSubmitClick}
        label="Submit"
      />

      <style jsx>{styles}</style>
    </div>
  );
};

export const toggleElectronicAccessModal = () => {
  const modal = document.querySelector('#electronicAccessModal');
  if (modal !== null) {
    modal.show();
  }
};
